"use client";

import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      position="top-right"
      toastOptions={{
        classNames: {
          // Toasts keep a floating surface, but a neutral one for every
          // variant; only the text carries the tone colour (no tinted panels).
          toast:
            "group toast group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-zinc-900 group-[.toast]:text-zinc-50 dark:group-[.toast]:bg-zinc-50 dark:group-[.toast]:text-zinc-900",
          cancelButton:
            "group-[.toast]:bg-zinc-100 group-[.toast]:text-zinc-500 dark:group-[.toast]:bg-zinc-800 dark:group-[.toast]:text-zinc-400",
          error:
            "group-[.toaster]:bg-card group-[.toaster]:border-border group-[.toaster]:text-red-600 dark:group-[.toaster]:text-red-400",
          success:
            "group-[.toaster]:bg-card group-[.toaster]:border-border group-[.toaster]:text-emerald-600 dark:group-[.toaster]:text-emerald-400",
          warning:
            "group-[.toaster]:bg-card group-[.toaster]:border-border group-[.toaster]:text-amber-600 dark:group-[.toaster]:text-amber-400",
          info:
            "group-[.toaster]:bg-card group-[.toaster]:border-border group-[.toaster]:text-sky-600 dark:group-[.toaster]:text-sky-400",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
